<template>
	<section class="d-flex w-100">

		<div class="d-flex flex-column" id="cancellations">

			<div class="row header-emotivi mb-3 justify-content-around align-items-end">
				<div class="col">
					<h1>Demandes de résiliations</h1>
				</div>
			</div>

			
			<div class="flex-grow-1 overflow-hidden d-flex">

				<div class="card card-no-margin">

					<h4>{{ cancellations_total }} demandes de résiliation</h4>

					<div class="d-flex justify-content-end align-items-start mb-3" style="margin-top: -60px">
						<m-form-select
							:width="300"
							label="Filter par statut"
							label-position="top"
							:name="$Utils.randomstring('filterStatus')"
							v-model="filterStatus"
							:items="$store.state.items_cr_statuses"
							@input="loadCancellations"
						/>
						<m-form-text
							class="ml-3"
							label="Rechercher"
							label-position="top"
							v-model="filterText"
							name="search"
							autocomplete
							@input="loadCancellations"
						/>
					</div>


					<m-list
						ref="cancellationslist"
						:dynamic="true"
						:items="cancellations"
						item-value="or_id"
						:item-height="30"
						:limit="cancellations_limit"
						:skip="cancellations_skip"
						:total="cancellations_total"
						:bgstrip="true"
						@changerange="cancellationsChangeRange"
						@itemclick="editCancellation"
					>
						<template v-slot:ths="{}">
							<th style="width: 40px">
							</th>
							<th style="width: 40px">
								#
							</th>
							<th>
								<span class="pointer">Contact</span>
							</th>
							<th>
								<span class="pointer">Bénéficiaire</span>
							</th>
							<th>
								<span class="pointer">Statut</span>
							</th>
							<th>
								<span class="pointer">Mis à jour le</span>
							</th>
							<th>
								<span class="pointer">Créée le</span>
							</th>
						</template>
						<template v-slot:tds="{ item }">
							<td style="width: 40px">
								<icon v-show="mustCallBack(item.cr_reason, item.cr_status)" name="phone-alt" scale="1.2" color="green"/>
								<icon v-show="isDead(item.cr_reason)" name="dizzy" scale="1.2" color="green"/>
							</td>
							<td :style="`width: 40px; background-color: ${isLate(item.cr_status_date)};`">
								<span class="position-relative">
									{{ item.cr_id }}
									<div v-show="isNew(item.cr_status)" class="label-new"></div>
								</span>
							</td>
							<td>
								{{ item.co_id.co_invoice_firstname }} {{ item.co_id.co_invoice_name }}
							</td>
							<td>
								{{ item.en_id ? item.en_id.en_fullname : "[donnée non disponible]" }}
							</td>
							<td>
								{{ getCancellationStatus(item.cr_status) }}
							</td>
							<td >
								{{ $moment(item.cr_status_date).format("DD/MM/YYYY HH[H]mm") }}
							</td>
							<td >
								{{ $moment(item.createdAt).format("DD/MM/YYYY HH[H]mm") }}
							</td>
						</template>
					</m-list>
						
					<cancellation-win-edit :row_cr_p="itemSelected" v-model="dialog" @reload="loadCancellations" />

				</div>

			</div>
		</div>
	</section>
</template>

<script>
export default {
  name: "cancellations",
  components: { },
  data() {
    return {

      cancellations: [],
      cancellations_total: 0,
      cancellations_limit: 50,
      cancellations_skip: 0,
      sortOrder: "asc",
      sortFields: [],
      row_en: {},
      filterText: "",
      filterStatus: "",
      itemSelected: {},
      dialog: false,
    };
  },

  watch: {

  },

  async mounted() {

    let id = parseInt(this.$route.params.or_id);

    if (id) {
      this.itemSelected.cr_id = id;
      this.dialog = true;
    }

    this.loadCancellations();

  },
  computed: {},
  methods: {

	mustCallBack(reason, status) {
		return reason.split('.').indexOf("CALL_ME_BACK") !== -1 && status === "INITIAL"
	},

	isDead(reason) {
		return reason.split('.').indexOf("DECEASED") !== -1
	},

	isNew(status) {
		return status === "INITIAL";
	},

	isLate(updatedAt) {

		const daysNb = this.$moment(updatedAt).diff(new Date(), 'days');

		let color;

		switch(daysNb) {
			case 7:
				color = "#e5e2b5";
				break;
			case 10:
				color = "#d9a2a2";
				break;
			default:
				color = "transparent";
				break;
		}

		return color;
	},

	getCancellationStatus(value) {
		const result = this.$store.state.items_cr_statuses.find(status => status.value === value);
		return result ? result.text : "???";
	},

    cancellationsChangeRange(skip) {
      this.cancellations_skip = skip;
      this.loadCancellations();
    },

    sortItems(fields) {
      if (fields.length && this.sortFields.length && fields[0] == this.sortFields[0]) {
        this.sortOrder = this.sortOrder == "asc" ? "desc" : "asc";
      }
      this.sortFields = fields;
      this.loadCancellations();
    },

    async loadCancellations() {

		let params = {
			skip: this.cancellations_skip,
			limit: this.cancellations_limit
		};

		if(this.filterText){
			params.search = this.filterText;
		}

		if(this.filterStatus){
			params.status = this.filterStatus;
		}

		this.cancelAxiosLoadCancellations && this.cancelAxiosLoadCancellations();

		let response = await this.$axios.get(`${this.$config.server_url}/extranet/2.0/cancellationRequest/list`, {
			params,
			cancelToken: new this.$axios.CancelToken(c => {
				this.cancelAxiosLoadCancellations = c;
			})
		});

		if(!response || !response.data){
			return;
		}

		this.cancellations = response.data.data;
		this.cancellations_total = response.data.meta.total;
    },

    editCancellation(item) {
      this.itemSelected = item;
      this.dialog = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../scss/styles.scss";

.label-new {
	position: absolute;
	right: -6px;
	top: 0px;
	width: 6px;
	height: 6px;
	background-color: #f00;
	border-radius: 3px;
}
</style>
